import {
  Camera,
  FileText,
  Package,
} from 'lucide-react';
import { cn } from '@/lib/classnames';
import type { AnalysisMode } from '@/features/receiving/types/ai-analysis';

interface QueueModeSelectProps {
  readonly selectedMode: AnalysisMode;
  readonly onModeChange: (mode: AnalysisMode) => void;
}

const MODES: {
  id: AnalysisMode;
  label: string;
  icon: typeof Camera;
}[] = [
  {
    id: 'box-counting',
    label: 'Box Count',
    icon: Package,
  },
  {
    id: 'invoice',
    label: 'Invoice',
    icon: FileText,
  },
  {
    id: 'product-verification',
    label: 'Product Label',
    icon: Package,
  },
];

export function QueueModeSelect({
  selectedMode,
  onModeChange,
}: QueueModeSelectProps) {
  return (
    <div className="flex gap-2">
      {MODES.map((mode) => (
        <button
          key={mode.id}
          type="button"
          onClick={() => onModeChange(mode.id)}
          className={cn(
            'flex items-center gap-2 px-3 py-2 rounded-lg border text-sm font-medium transition-colors',
            selectedMode === mode.id
              ? 'border-blue-500 bg-blue-50 text-blue-700'
              : 'border-gray-200 bg-white text-gray-600 hover:bg-gray-50'
          )}
        >
          <mode.icon className="w-4 h-4" />
          {mode.label}
        </button>
      ))}
    </div>
  );
}
